import { render, staticRenderFns } from "./ChatDropdown.vue?vue&type=template&id=8187cffe"
import script from "./ChatDropdown.vue?vue&type=script&lang=js"
export * from "./ChatDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports